import { cloneElement, Component } from 'preact';
import PropTypes from "prop-types";
import withConfiguration from "../shared/hoc/withConfiguration";
import Loading from "../shared/Loading";
import OutOfOrderPage from "../../routes/Location/OutOfOrderPage";
import { configurationThunk } from "../../store/store";

class ConfigurationLoader extends Component {
	componentDidMount() {
		configurationThunk.getConfiguration();
	}

	render({children, configurationStates, configuration}) {
		let {fetching, failed} = configurationStates;

		if(fetching) return <Loading title={"initializing"} style={{fontSize: "3em"}}/>;

		if(failed) return <OutOfOrderPage style={{height: "100%"}} message={"location.outOfOrder.configuration.message"} error={configurationStates.error}/>;

		return cloneElement(children, {configuration, configurationStates});
	}

	static get propTypes() {
		return {
			children: PropTypes.any,

			configurationStates: PropTypes.object,
		}
	}
}

export default withConfiguration(ConfigurationLoader);
